var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFuncaoArredondarMenos01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2197",
    transform: "translate(59.285 681.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1206",
    d: "M-55.7-664.8h5.5l-4.5,15.3h-4.1L-55.7-664.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1207",
    d: "M-43.9-678.3h20.2v4.7h-20.2V-678.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFuncaoArredondarMenos01);
export default __webpack_public_path__ + "static/media/ico-funcao-arredondar-menos-01.106d894730a603bc952238f7c5d84e5e.svg";
export { ForwardRef as ReactComponent };